import { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Bell, House, Money, Notebook, User } from "@phosphor-icons/react";
import DuressButton from "@/components/DuressButton";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const TABS = [
  { to: "/m", label: "Shifts", icon: House, end: true, testid: "tab-shifts" },
  { to: "/m/reports", label: "Reports", icon: Notebook, end: false, testid: "tab-reports" },
  { to: "/m/alerts", label: "Alerts", icon: Bell, end: false, testid: "tab-alerts" },
  { to: "/m/pay", label: "Pay", icon: Money, end: false, testid: "tab-pay" },
  { to: "/m/profile", label: "Profile", icon: User, end: false, testid: "tab-profile" },
];

export default function MobileLayout() {
  const { user } = useAuth();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    const load = () => api.get("/notifications/unread-count").then((r) => setUnread(r.data.count)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="dark">
      <div className="min-h-screen bg-background text-foreground max-w-md mx-auto border-x border-border pb-24" data-testid="mobile-shell">
        <header className="sticky top-0 z-30 bg-background border-b border-border px-4 h-12 flex items-center justify-between">
          <span className="font-heading font-black tracking-tight">AEGIS<span className="text-[hsl(var(--warning))]">OPS</span></span>
          <div className="flex items-center gap-2.5">
            <span className="font-mono text-[10px] uppercase text-muted-foreground truncate max-w-[9rem]" data-testid="mobile-user-name">{user.name}</span>
            {/* In the SHELL, not on a screen. A guard reaching for this is not
                going to navigate to a tab first, and the one moment it is needed
                is the one moment nobody is going to look for it. */}
            <DuressButton />
          </div>
        </header>
        <Outlet />
        <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-card border-t border-border z-40" data-testid="mobile-bottom-nav">
          <div className="grid grid-cols-5">
            {TABS.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                data-testid={t.testid}
                className={({ isActive }) =>
                  `flex flex-col items-center gap-1 py-3 transition-colors duration-150 ${isActive ? "text-[hsl(var(--warning))]" : "text-muted-foreground"}`
                }
              >
                {({ isActive }) => (
                  <>
                    <span className="relative">
                      <t.icon size={22} weight={isActive ? "fill" : "duotone"} />
                      {t.testid === "tab-alerts" && unread > 0 && (
                        <span data-testid="mobile-unread-badge" className="absolute -top-1 -right-2 bg-[hsl(var(--alert))] text-white font-mono text-[9px] px-1">{unread}</span>
                      )}
                    </span>
                    <span className="text-[10px] font-semibold uppercase tracking-wider">{t.label}</span>
                  </>
                )}
              </NavLink>
            ))}
          </div>
        </nav>
      </div>
    </div>
  );
}
